import { useEffect, useRef } from "react";
import "./styles.scss";
import { Link, useLocation } from "react-router-dom";
import Slider from "react-slick";


const useScrollToLocation = () => {
  const scrolledRef = useRef(false);
  const { hash } = useLocation();
  const hashRef = useRef(hash);

  useEffect(() => {
    if (hash) {
      // We want to reset if the hash has changed
      if (hashRef.current !== hash) {
        hashRef.current = hash;
        scrolledRef.current = false;
      }

      // only attempt to scroll if we haven't yet (this could have just reset above if hash changed)
      if (!scrolledRef.current) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          scrolledRef.current = true;
        }
      }
    } else {
      window.scrollTo(0, 0)
    }
  });
};

const Home = () => {
  useScrollToLocation();

  return (
    <div className="home">
      <section className="hero-wrap">
        <div className="container">
          <div className="content d-flex justify-content-center align-items-center">
            <div className="col-md-12 text-center">
              <h1>
                Find a <span>Community of Believers</span> to Belong to!
              </h1>
              <p>
                At Celebration Church International (CCI) USA, you will find a warm and
                welcoming atmosphere where you can connect with others, deepen
                your relationship with God, and walk in your purpose.
              </p>
              <a href="https://bit.ly/cciusmap" rel="noreferrer" target="_blank">
                <button className="btn btn-main">
                  <i className="fa-solid fa-magnifying-glass mr-1"></i> Find
                  your location
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="about section" id="map">
        <div className="container">
          <div className="row content justify-content-center align-items-center">
            <div className="col-md-12 offset-md-1s">
              <h1 data-aos="fade-in">
                Find a <span>MAP</span> close to you
              </h1>
              <p data-aos="fade-in">
                MAP (Meet and Pray) is an initiative of CCI where members that
                reside in the same vicinity can strengthen each other in
                spiritual growth and build bonds.
              </p>
              <div className="map-locations">
                {Object.keys(MAPLocations).map((item, index) => {
                  return (
                    <a href={MAPLocations[item]} key={index} rel="noreferrer" target="_blank" data-aos="fade-in">
                      <button className="swipe-button" >
                        <i className="fa-solid fa-map-pin mr-1"></i> {item}
                      </button>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about section yellow" id="cell-church">
        <div className="container">
          <div className="row content flex-row-reverses justify-content-center align-items-center">
            <div className="col-md-12">
              <h1
                data-aos="fade-up"
                data-aos-duration="600"
                className="text-center text-white"
              >
                Find a <span>Main Campus</span> close to you
              </h1>
              <div className="row justify-content-center">
                <div className="col-md-8 text-center">
                  <p data-aos="fade-up" data-aos-duration="600">
                    We are currently in 2 locations. Join us on Sunday mornings
                    for a great time of fellowship.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-center">
              {MainBranchLocations.map((item, index) => {
                return (
                  <div
                    className="col-md-4"
                    key={index}
                    data-aos="fade-up"
                    data-aos-duration="600"
                  >
                    <div className="cont">
                      <img
                        alt={item.location}
                        src={item.image}
                        className="img-fluid"
                      />
                      <div className="inner">
                        <h4>{item.location}</h4>
                        <p>
                          <i className="fa-solid fa-clock mr-1"></i>{" "}
                          <b>Time:</b> {item.time}
                        </p>
                        <p>
                          <i className="fa-solid fa-map-pin mr-1"></i>{" "}
                          <b>Venue:</b> {item.venue}
                        </p>
                        <Link
                          to={item.instagram}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <button className="btn instagram-btn w-full">
                            <i className="fa-brands fa-instagram mr-1"></i>{" "}
                            Connect on Instagram
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>

      <section className="about section black" id="cell-church">
        <div className="container">
          <div className="row content flex-row-reverses justify-content-center align-items-center">
            <div className="col-md-12">
              <h1 data-aos="fade-in">
                Find a <span>Cell Church</span> close to you
              </h1>
              <p data-aos="fade-in">
                It is also known as a house church. This is the smallest unit of
                a church body where, despite the absence of a main CCI branch,
                members meet every Sunday to fellowship together and hold each
                other accountable.
              </p>
            </div>
          </div>
          <div className="row" style={{ marginTop: "10px" }}>
            {CellChurchLocations.map((item, index) => {
              return (
                <div className="col-md-4" key={index} data-aos="fade-in">
                  <div className="cont">
                    <img
                      src={item.image}
                      className="img-fluid"
                      alt={item.location}
                    />
                    <div className="inner">
                      <h4>
                        <i className="fa-solid fa-church mr-1"></i>{" "}
                        {item.location}
                      </h4>
                      <p>
                        <i className="fa-solid fa-clock mr-1"></i> <b>Time:</b>{" "}
                        {item.time}
                      </p>
                      <p>
                        <i className="fa-solid fa-map-pin mr-1"></i>{" "}
                        <b>Venue:</b> {item.venue}
                      </p>
                      <p>
                        <i className="fa-solid fa-phone mr-1"></i> Contact{" "}
                        {item.contact}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="about section yellow" id="interest-groups">
        <div className="container">
          <div className="row content justify-content-center align-items-center">
            <div className="col-md-5">
              <img
                src="https://img.freepik.com/free-photo/ladder-with-wooden-cubes-arrow_23-2148879390.jpg?ga=GA1.1.1561807298.1721746052&semt=ais_user"
                className="img-fluid side"
                data-aos="fade-in"
                alt="Groups"
              />
            </div>
            <div className="col-md-6 offset-md-1">
              <h1 data-aos="fade-in">
                Career Development and <span>Interest Groups</span>
              </h1>
              <p data-aos="fade-in">
                Looking for opportunities to grow professionally and
                recreationally? Looking to invite non-Christian friends to a
                church community? Check out these various groups and development
                opportunities!
              </p>
              <div className="map-locations">
                {Object.keys(InterestGroups).map((item, index) => {
                  return (
                    <a href={InterestGroups[item]} rel="noreferrer" target="_blank" key={index} data-aos="fade-in">
                      <button className="swipe-button">
                        <i className="fa-solid fa-user-group mr-1"></i> {item}
                      </button>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about section black" id="resources">
        <div className="container">
          <div className="row content justify-content-center align-items-center">
            <div className="col-md-12">
              <h1 data-aos="fade-in">Other Resources</h1>
            </div>
          </div>
          <div className="row" style={{ marginTop: "10px" }}>
            {announcements.map((item, index) => {
              return (
                <div className="col-md-4" key={index} data-aos="fade-in">
                  <div className="cont">
                    <img src={item.image} className="img-fluid" alt={item.name} />
                    <div className="inner">
                      <h4>
                        <i className="fa-regular fa-bell mr-1"></i> {item.name}
                      </h4>
                      <p> {item.description}</p>
                      <a href={item.link} rel="noreferrer" target="_blank">
                        <button className="btn btn-md btn-connect">
                          <i className="fa-solid fa-link mr-1"></i>{" "}
                          {item.linkText}
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="cta section" id="contact">
        <div className="container">
          <div className="row content justify-content-center align-items-center">
            <div className="content">
              <h1 data-aos="fade-in">Want to Get more connected?</h1>
              <p data-aos="fade-in"><i className="fa-solid fa-chevron-right mr-1"></i> Learn more about our ministry at <a rel="noreferrer" target="_blank" href="https://joincci.org/">joincci.org</a></p>
              <p data-aos="fade-up" data-aos-duration="600">
                <i className="fa-solid fa-chevron-right mr-1"></i> Want to have a one-on-one meeting with a Pastor?{" "}
                <Link to="/connect">
                Book a time slot
                </Link>
              </p>
              <p data-aos="fade-in"><i className="fa-solid fa-chevron-right mr-1"></i> Have questions? Send an email to <a rel="noreferrer" target="_blank" href="mailto:info.usa@joincci.org">info.usa@joincci.org</a></p>
              <p data-aos="fade-in"><i className="fa-solid fa-chevron-right mr-1"></i> Want to partner with us? Give via this link <a rel="noreferrer" target="_blank" href="https://bit.ly/GiveCCIUSA">bit.ly/GiveCCIUSA</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

const MAPLocations: any = {
  "Austin, TX": "https://chat.whatsapp.com/GHKuYLRVIUT0aU9f4ibYE1",
  Connecticut: "https://chat.whatsapp.com/FhKfvpjcPOXKpI84OU1Vft",
  "North Dallas, TX": "https://chat.whatsapp.com/KohMW9tyuwYK73lIYsEHHN",
  "Central Dallas, TX": "https://chat.whatsapp.com/KohMW9tyuwYK73lIYsEHHN",
  "DC & Virginia": "https://chat.whatsapp.com/Bk1gjebbMO6IZIu8zMNNUe",
  "Maryland": "https://chat.whatsapp.com/Bk1gjebbMO6IZIu8zMNNUe",
  "Florida": "https://chat.whatsapp.com/EEnElrmXXM7GAHueFvHCqS",
  "Georgia": "https://chat.whatsapp.com/Kd4dsAT9uZ30HVPT5fhrZm",
  "Illinois": "https://chat.whatsapp.com/ER5s18xui218sVUGgrfl5b",
  "Indiana": "https://chat.whatsapp.com/Kl59wva2QBID5b6Sa5zKPE",
  "Ithaca": "https://chat.whatsapp.com/GDMpyhW44Da2q1MP6iGYWS",
  "Nashville, TN": "https://chat.whatsapp.com/IAeIYgcQ2G0DOoBCJsCHRv",
  "Knoxville/Cleveland, TN": "https://chat.whatsapp.com/CxZb1dRzyU9JdRx5sjdeau",
  "Massachusetts": "https://chat.whatsapp.com/JDUA7OobxiiIhXovG7XUs",
  "Minnesota": "https://chat.whatsapp.com/LjTUm7OpUpbLn4n5VzimYJ",
  "Raleigh, NC": "https://chat.whatsapp.com/BW03MCyslF8FpGExnu73n6",
  "Charlotte, NC": "https://chat.whatsapp.com/BW03MCyslF8FpGExnu73n6",
  "New York/New Jersey": "https://chat.whatsapp.com/CGnmZR496KW3IsjBkB4sfl",
  "Oklahoma": "https://chat.whatsapp.com/LuHJTQGwTWd14WbibSJhN7",
  "Ohio": "https://chat.whatsapp.com/J0Po54mkRa01DXnlql1B0u",
  "San Francisco": "https://chat.whatsapp.com/HyER6loVazQ3OgIkRxV45k",
  "Los Angeles": "https://chat.whatsapp.com/HyER6loVazQ3OgIkRxV45k",
  "Las Vegas": "https://chat.whatsapp.com/HyER6loVazQ3OgIkRxV45k",
  "Washington": "https://chat.whatsapp.com/HyER6loVazQ3OgIkRxV45k",
  "San Antonio": "https://chat.whatsapp.com/Hc0M5ezuIFw8IbMDVmNrti",
  "Kentucky": "https://chat.whatsapp.com/DRDuzt5WvAxE6cIO2GmCIr",
  "Houston": "https://chat.whatsapp.com/IkNmPr27Zl56BKfamHkX22"
};

const MainBranchLocations = [
  {
    location: "Dallas",
    time: "10am CST",
    venue:
      "300 Chisholm Place, Plano, Texas 75075",
    instagram:
      "https://www.instagram.com/cci_dallas",
    image: require("../../assets/images/main_branches/dallas/Snapinst.app_485186082_3062202587261587_6159335500613699966_n_1080.jpg"),
  },
  {
    location: "DMV ",
    time: "10am EST",
    venue: "The Shed DMV, 5650 Rivertech Ct Suite Q,, Riverdale, Maryland 20737",
    instagram: "https://www.instagram.com/cci_dmv",
    image: require("../../assets/images/main_branches/dmv/Snapinst.app_482699312_17926001256020844_4031973441339571746_n_1080.jpg"),
  }
];

const CellChurchLocations = [
  {
    location: "Austin",
    time: "10am CST",
    venue: "603A Caterpillar Lane, Pflugerville, TX 78660",
    contact: "Sorochi: (718) 790-7782",
    image: require("../../assets/images/austin.jpg")
  },
  {
    location: "Knoxville/Cleveland",
    time: "10am EST",
    venue: "103B, Humanities and Social Sciences Building, 1115 Volunteer Boulevard, Knoxville, TN, 37916",
    contact: "Samuel: (865) 910-3727 ",
    image: require("../../assets/images/tn.jpg")
  },
  {
    location: "Massachusetts",
    time: "10am EST",
    venue: "1060 Broadway Unit, C101B, Somerville, MA",
    contact: "Olamide: (339) 241-0003",
    image: require("../../assets/images/ma.jpg")
  },
  {
    location: "North Carolina",
    time: "10am EST",
    venue: "1901 NW Cary Pkwy Ste 105 Morrisville, NC 27560",
    contact: "John: (984) 683-2927",
    image: require("../../assets/images/nc.jpg")
  },
  {
    location: "New York/New Jersey",
    time: "10am EST",
    venue: "2nd Floor, 134 W 29th Street New York, NY 10001",
    contact: "Abraham: (973) 757-3293",
    image: require("../../assets/images/ny.jpg")
  },
];

const InterestGroups: any = {
  Entrepreneurs: "https://chat.whatsapp.com/DBCD4HeWK3i4aGoEn4sQQA",
  Healthcare: "https://chat.whatsapp.com/BnAIcTrXrhn2fGhnrCdEll",
  Legal: "https://chat.whatsapp.com/GDVJQ1Z7e2YGcx53mCTQO9",
  "Media and Creatives": "https://chat.whatsapp.com/EOdL0pC5xFQAjakG8PML8a",
  Education: "https://chat.whatsapp.com/EcZ9dvkcp25BxqPV2Tvdsc",
  "Business and HR": "https://chat.whatsapp.com/EhfNE17GZEvG10UCh6let1",
};

const announcements = [
  {
    name: "Triumph 30",
    description:
      "Develop a thriving prayer and Bible study life with our daily devotional platform. Our prayer times are 12am, 6am, 2pm, and 8pm. (CST).",
    link: "https://t30.org/",
    image: require("../../assets/images/t30.jpg"),
    linkText: "Connect here",
  },
  {
    name: "CCI NA Vigil",
    description:
      "We gather for long stretch of prayers on Zoom every second Friday of the month starting by 10pm CST.",
    link: "http://bit.ly/CCINAVigil",
    image: require("../../assets/images/vigil.jpeg"),
    linkText: "Register here",
  },
  {
    name: "CCI NA MDWK Service",
    description:
      "Join us every Wednesday for a time exploring more of our teaching series for the month and prayers by 6pm CST.",
    link: "https://bit.ly/CCINAMDWKSERVICE",
    image: require("../../assets/images/mdwk.jpeg"),
    linkText: "Register here",
  },
];